import React from 'react'

import Carousel from 'components/ui/Carousel/Carousel'


const options = {
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  initialSlide: 0,
  adaptiveHeight: true,
  slidesToScroll: 1,
  autoplay: false,
  arrows: false,
  swipe: true,
  touchMove: true,
  useCSS: true,
}

const GiftSetsCarousel = ({ children }) => (
  <Carousel options={options}>
    {children}
  </Carousel>
)


export default GiftSetsCarousel
